import * as React from "react";
import { styled, alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import MenuItem from "@mui/material/MenuItem";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Sitemark from "./SitemarkIcon";
import "./AppAppBar.css";
import { Link, NavLink } from "react-router-dom";

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexShrink: 0,
  borderRadius: `calc(${theme.shape.borderRadius}px + 8px)`,
  backdropFilter: "blur(24px)",
  border: "1px solid",
  borderColor: theme.palette.divider,
  backgroundColor: alpha(theme.palette.background.default, 0.4),
  boxShadow: theme.shadows[1],
  padding: "8px 12px",
}));

export default function AppAppBar() {
  const [open, setOpen] = React.useState(false);
  const [token, setToken] = React.useState('');

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  React.useEffect(() => {
    setToken(localStorage.getItem("Token"));
  }, []);

  return (
    <AppBar
      position="fixed"
      sx={{
        boxShadow: 0,
        bgcolor: "transparent",
        backgroundImage: "none",
        mt: 10,
      }}
    >
      <Container maxWidth="lg">
        <StyledToolbar variant="dense" disableGutters>
          <Box
            sx={{ flexGrow: 1, display: "flex", alignItems: "center", px: 0 }}
          >
            {/* <Sitemark /> */}
            <img src="contract.png" style={{
                  width: "100px",
                  height: "66px",
                  objectFit: "cover"
            }} alt="" srcset="" />
            <Box sx={{ display: { xs: "none", md: "flex" } }}>
              <Button variant="text" color="info" size="small" href="#features">
                Features
              </Button>
              <Button variant="text" color="info" size="small" href="#testimonials">
              Testimonials
              </Button>
              <Button variant="text" color="info" size="small" href="#faq">
                About us
              </Button>
              {/* <Button variant="text" color="info" size="small">
                Private Markets
              </Button> */}
                {/* <Button
                  variant="text"
                  color="info"
                  size="small"
                  sx={{ minWidth: 0 }}
                  href="#pricing"
                >
                         
                  Pricing
                </Button> */}

              {/* <Button variant="text" color="info" size="small" style={{fontWeight:"bolder"}}>
                <NavLink to="/get-demo">
                  Get a Demo
                </NavLink>
              </Button>  */}
            </Box>
          </Box>
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              gap: 1,
              alignItems: "center",
            }}
          >
            {
             !token && <NavLink to="/get-demo" style={{ textDecoration: "none" }}>
                <Button color="primary" variant="text" size="small">
                  Request Demo
                </Button>
              </NavLink>
            }

            {
             !token && <NavLink to="/login" style={{ textDecoration: "none" }}>
                <Button color="primary" variant="text" size="small">
                  Sign in
                </Button>
              </NavLink>
            }

            {
             token && <NavLink to="/dashboard" style={{ textDecoration: "none" }}>
                <Button color="primary" variant="text" size="small">
                  Dashboard
                </Button>
              </NavLink>
            }

          </Box>
          <Box sx={{ display: { sm: "flex", md: "none" } }}>
            <IconButton aria-label="Menu button" onClick={toggleDrawer(true)}>
              <MenuIcon />
            </IconButton>
            <Drawer anchor="top" open={open} onClose={toggleDrawer(false)}>
              <Box sx={{ p: 2, backgroundColor: "background.default" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <IconButton onClick={toggleDrawer(false)}>
                    <CloseRoundedIcon />
                  </IconButton>
                </Box>
                <Divider sx={{ my: 3 }} />
                <MenuItem>
                <Button variant="text" color="info" size="small" href="#features">
                  Features
                </Button>
              </MenuItem>
                <MenuItem>
                <Button variant="text" color="info" size="small" href="#testimonials">
                Testimonials
              </Button>
                </MenuItem>
                <MenuItem>
                <Button variant="text" color="info" size="small" href="#highlights">
                Highlights
              </Button>
                </MenuItem>
                {/* <MenuItem>
                <Button variant="text" color="info" size="small" href="#pricing">
                <Link to="/get-demo">Get a demo</Link>
              </Button>
                </MenuItem> */}
                <MenuItem>
                <Button variant="text" color="info" size="small" href="#faq">
                About us
              </Button>
                </MenuItem>
                <MenuItem>
                {/* <Button variant="text" color="info" size="small" href="#features">
                Blog
              </Button> */}
                </MenuItem>
                <MenuItem>
                {
                 !token && <NavLink to="/get-demo" style={{ textDecoration: "none", marginRight: "4px" }}>
                  <Button color="primary" variant="outlined" fullWidth>
                    Request Demo
                  </Button>
                </NavLink>
                }
                
                {
                 !token && <NavLink to="/login" style={{ textDecoration: "none" }}>
                  <Button color="primary" variant="outlined" fullWidth>
                    Sign in
                  </Button>
                </NavLink>
                }

                {
                  token && <NavLink to="/dashboard" style={{ textDecoration: "none" }}>
                      <Button color="primary" variant="outlined" fullWidth>
                          Dashboard
                      </Button>
                    </NavLink>
                }
                </MenuItem>
              </Box>
            </Drawer>
          </Box>
        </StyledToolbar>
      </Container>
    </AppBar>
  );
}
